import axios from 'axios'
import RootModule from '@/common/store/RootModule'

const AppAuthenticationKey = 'App-Authentication'
axios.interceptors.request.use(config => {
  config.headers[AppAuthenticationKey] = `Basic ${process.env.VUE_APP_KEY}`
  return config
})

axios.interceptors.response.use(response => {
  const timestamp = response.headers['current-timestamp']
  RootModule.setCurrentSystemTime(timestamp)
  return response
})
